import { Component, OnInit, Injector } from '@angular/core';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BillingpopupComponent } from 'src/modules/billing/components/billingpopup/billingpopup.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';

@Component({
    selector: 'app-counselling',
    templateUrl: `../../../base/components/ui-engine/ui-engine.component.html`,
    styleUrls: ['./counselling.component.scss'],
    standalone: false
})
export class CounsellingComponent extends UiEngineComponent {
  sessionData: any;
  bannerJson: { selector: string; component : string , datasource: { application: string; resource: string; query_id: string; }; jsonName: string; };


  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService
  ) {
    super(injector, router, route, modal);

  }
  public routeResource;
  initConfigForForm(resource_def) {
    super.initConfigForForm(resource_def);
    // #190342 - keep scroll-tab blocks independently collapsible (config.expanded_form in JSON)
    if (this?.route?.snapshot?.routeConfig?.path?.includes('counselling_detail_add') && resource_def?.config?.expanded_form != undefined) {
      this._currentData.configForm.expanded_form = resource_def.config.expanded_form;
    }
  }
  getByQueryID(apiObj?) {
    this.loader.showSpinner();
    if (apiObj == undefined) {
      this.route.params.subscribe(v =>
        this.routeResource = v)
      var apiObj: any = {};
      apiObj.resource = this._currentData.currentFormFields.datasource.resource != undefined ? this._currentData.currentFormFields.datasource.resource : this._currentData.resource;
      apiObj.application = this._currentData.currentFormFields.datasource.application != undefined ? this._currentData.currentFormFields.datasource.application : this.appService.getApplication();
      apiObj.key = this._currentData.currentFormFields.datasource.key != undefined ? this._currentData.currentFormFields.datasource.key : 'id';
      apiObj.query_id = this._currentData.currentFormFields.datasource.query_id != undefined ? this._currentData.currentFormFields.datasource.query_id : "GET_BY_ID";
      apiObj.args = this._currentData.currentFormFields.datasource.args != undefined ? this._currentData.currentFormFields.datasource.args : 'dummy:dummy';
      apiObj.args = apiObj.key + ":" + this.routeResource.resource + ',' + apiObj.args;
    }

    this.baseService.get(apiObj.query_id, apiObj.args, apiObj.resource, apiObj.application).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        } else {
          if (data.resource != undefined && data.resource.length > 0) {
            this._currentData.currentData = data.resource[0];
          } else {
            this._currentData.currentData = [];
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    )
  }
  onSaveFinished(event) {
    // return false
    if (event.result.extra_data.templateId) {
      var finalObj: any = {};
      finalObj['templateId'] = event.result.extra_data.templateId;
      finalObj['templateName'] = event.result.extra_data.templateName;
      finalObj['templateType'] = event.result.extra_data.templateType;
      finalObj['title'] = event.result.extra_data.title;
      finalObj['isConfidential'] = "";
      Object.keys(event.result.extra_data).forEach(key => {
          if (typeof event.result.extra_data[key] == 'object')
          event.result.extra_data[key] = JSON.stringify(event.result.extra_data[key]);
      })
      finalObj['template'] = event.result.extra_data;
      setTimeout(() => {
        if(event.result.observation_id)
        {
          finalObj['id'] = event.result.observation_id;
          this.formService.baseService.action(finalObj, 'TemplateUpdateBaseOnId', 'emr', 'observation_emr_templates').subscribe(
            (data: any) => {
              if (data.errCode != -1) {
                if (data != undefined && data.resource != undefined && data.resource.length > 0) {
                  event.result['observation_id'] = data.resource[0].id;
                  switch (event.currentBtnVal.label) {
                    case 'button.final':
                      this.saveData(event);
                      break;
                    case 'button.draft':
                      this.saveData(event);
                      break;
                  }
                }
              }
            })
        }
        else{
        this.formService.baseService.action(finalObj, 'AddTemplate', 'emr', 'observation_emr_templates').subscribe(
          (data: any) => {
            if (data.errCode != -1) {
              if (data != undefined && data.resource != undefined && data.resource.length > 0) {
                event.result['observation_id'] = data.resource[0].id;
                switch (event.currentBtnVal.label) {
                  case 'button.final':
                    this.saveData(event);
                    break;
                  case 'button.draft':
                    this.saveData(event);
                    break;
                }
              }
            }
          })
        }
      })
    }
    else {
      switch (event.currentBtnVal.label) {
        case 'button.final':
          this.saveData(event);
          break;
        case 'button.draft':
          this.saveData(event);
          break;
      }
    }
  }
  threeDotClick(event) {
      this.sessionData = JSON.parse(sessionStorage.getItem('currentData'));
    if (this?.route?.snapshot?.routeConfig?.path?.includes('counselling_detail_add')) {
      this.bannerJson = {
        "selector": "emr-patient-layout",
        "component": "hidden",
        "datasource": {
          "application": "patient-registration",
          "resource": "patient",
          "query_id": "GET_BY_ID"
        },
        "jsonName": "banner_op_emr"
      }
    }
    else {
      this.bannerJson = {
        "selector": "emr-patient-layout",
        "component": "hidden",
        "datasource": {
          "application": "adt",
          "resource": "counselling_detail",
          "query_id": "GET_BY_ID"
        },
        "jsonName": "banner_op_emr"
      }
    }
 
  if(event.event.event.action == 'viewEmr'){
  this.router.navigate(['/emr/view/view_medical_records/emrView'],{queryParams : {key : this.sessionData.id , banner : JSON.stringify(this.bannerJson)}});
  }
  // if(event.event.event.action == 'showVisits'){
  //   this.router.navigate(['/emr/patientlist_format/emr_op_patient/emrDesign'],{queryParams : {key : this.sessionData.id , banner : JSON.stringify(this.bannerJson)}});
  // }
  if(event.event.event.action == 'VIEW_PATIENT_DOCUMENTS'){
    var data = {
      action: 'IMAGE_VIEWER',
      query_id: 'GET_BY_ID',
      resource: { "resource": "uploadedfile_metadata" },
      args:
        "facility_id:" + this.sessionData.facility_id + ",id:" +  this.sessionData.id
    }
    this.route.snapshot.data.resource = "uploadedfile_metadata";
    this.baseService.getData(data, "", 'patient', 'patient-registration', 'GET_BY_ID').subscribe(
      result => {
        if (result.errCode == 0 && result.resource != undefined && result.resource.length > 0) {
          this.storageService.setSessionStorageData("currentData", result.resource[0], () => {
            console.log("saved");
            this.baseService.modalService.dialogService.open(BillingpopupComponent, { size: DialogModalSize.Lg, title: "Patient Documents", data }).afterClosed.subscribe(data => { }, err => { })
          });
        }
      }
    )
  }
  }
  saveData(event, callback = null) {
    this.loader.showSpinner();
    if (this._currentData.currentAction == 'MODIFY') {
      if (event.currentBtnVal.label === "button.final") {
        event.result.stages = "Final";
        event.result.id = this._currentData.currentData.id;
        if(event.result.payer_type=="cash"){
          delete event.result.authorization_amount
       }
      }
      else {
        event.result.stages = "Draft";
      }
    } else if (this._currentData.currentAction == 'ADD') {
      if (event.currentBtnVal.label === "button.final") {
        event.result.stages = "Final";
        delete event.result.id;
        delete event.result.g_creation_time;
        
      }
      else {
        event.result.stages = "Draft";
        delete event.result.id;
        delete event.result.g_creation_time;
      }
    }
    var resource = '';
    var application = '';
    var action = '';
    if (this._currentData.currentFormFields.APIresource && this._currentData.currentFormFields.APIresource != undefined) {
      console.log("API Resource", this._currentData.currentFormFields.APIresource)
      resource = this._currentData.currentFormFields.APIresource.datasource['resource'];
      application = this._currentData.currentFormFields.APIresource.datasource['application'];
      if (this._currentData.currentFormFields.APIresource.datasource.action != undefined) {
        action = this._currentData.currentFormFields.APIresource.datasource.action;
      } else {
        action = this._currentData.currentAction;
      }
    } else {
      resource = this._currentData.resouceDef.resource;
      application = '';
       if(event && event.result && event.result.copy_counselling_from == 'Draft' && event.result.copy_counselling){
        action = 'ADD_COPY_COUNSELLING'
      }
      else if((this._currentData.resouceDef.resource == 'counselling_draft' && this?.route?.snapshot?.params?.id == 'counselling_requested') || (!event.result.copy_counselling && this?._currentData?.resouceDef?.resource == 'counselling_draft')){
      action = 'MODIFY_DRAFT_COUNSELLING'
      }
      else{
        action = this._currentData.currentAction;
      }
    }
    event.result = { ...event.result, ...this._currentData.foreignKeyData };
    this.baseService.action(event.result, action, application, resource).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          if (callback) {
            callback(false);
          }
        } else {
          this.communicationService.emitChange({ completed: true });
          if (this._currentData.currentAction == 'ADD') {
            this.alerts.success("Added Successfully");
          } else {
            this.alerts.success("Updated Successfully");
          }
          var redirectLogic = true;
          /******** DEOCRATOR IMPLEMENTATION *******/
          if (this._currentData.decorator != undefined && this._currentData.decorator) {
            redirectLogic = this._currentData.decorator.afterSubmitReqSuccess(event, data, this.formComponenet);
          }
          /******** DEOCRATOR IMPLEMENTATION *******/

          if (redirectLogic) {
            this.formComponenet.resetFormClick();
            if (event.currentBtnVal.action != undefined && ['print', 'download', 'view_file'].indexOf(event.currentBtnVal.action) > -1) {
              this.handleFile(event.currentBtnVal, { data: data.resource[0] }, (response) => {
                if (!response) {
                  this.alerts.error("Print Error");
                }
                if (this._layout == 'tab') {
                  this.router.navigate(['.'], { relativeTo: this.route, queryParams: { "tab": this.route.snapshot.queryParams.tab_0, "returnUrl": this.route.snapshot.queryParams.returnUrl, "key": this.route.snapshot.queryParams.key } });
                } else {
                  this.listResource(event.currentBtnVal, data);
                }
              });
            } else {
              if (this._layout == 'tab') {
                this.router.navigate(['.'], { relativeTo: this.route, queryParams: { "tab": this.route.snapshot.queryParams.tab_0, "returnUrl": this.route.snapshot.queryParams.returnUrl, "key": this.route.snapshot.queryParams.key } });
              } else {
                this.listResource(event.currentBtnVal, data);
              }
            }
          }

        }
        this.loader.hideSpinner();
        if (callback != null) {
          data['resourceName'] = resource;
          callback(data);
        }
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
        if (callback) {
          callback(false);
        }
      }
    )
  }


}
